<template>
  <div>
    <v-btn v-if="props.habilitar_botao_grande" class="ml-4" small color="primary" @click="abrirDialog">
      <v-icon :size="21" class="mr-1">$PackageVariantClosedRemove</v-icon>
      {{ DESCONSIDERAR_PEDIDO_TRANSITO_COMPUTED ? 'Desconsiderar' : 'Considerar' }} pedido{{ pedidos.length > 1 ? 's' : ''}}
    </v-btn>

    <v-btn v-else icon :color="!DESCONSIDERAR_PEDIDO_TRANSITO_COMPUTED ? '#CECECE' : ''" @click="abrirDialog">
      <v-icon>$PackageVariantClosedRemove</v-icon>
    </v-btn>

    <SysDialog
      v-model="dialog_ativo"
      :titulo="TITULO_COMPUTED"
      txt-botao="confirmar"
      :largura="500"
      @click:primary="desconsiderarPedidosConsumos"
    >
      <p v-html="MENSAGEM_TEXTO_COMPUTED" />
    </SysDialog>
  </div>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {computed, ref} from "vue";
import api from "@/api/api";
import {logout} from "@/helpers";

const props= defineProps({
  idgrupo: Number,
  idfornecedor: Number,
  pedidos: Array,
  habilitar_botao_grande: Boolean,
});

const emit = defineEmits(['consumos-desconsiderados']);

const dialog_ativo = ref(false);

function abrirDialog() {
  dialog_ativo.value = true;
}

const DESCONSIDERAR_PEDIDO_TRANSITO_COMPUTED = computed(() => {
  return props.pedidos.some(item => !item.pedido_desconsiderado);
});

const TITULO_COMPUTED = computed(() => {
  return DESCONSIDERAR_PEDIDO_TRANSITO_COMPUTED.value
    ? `Desconsiderar o pedido de venda`
    : `Considerar o pedido de venda`
});

const MENSAGEM_TEXTO_COMPUTED = computed(() => {
  return DESCONSIDERAR_PEDIDO_TRANSITO_COMPUTED.value
    ? `Marcando essa opção o <span class="font-weight-medium">Systock</span> não irá considerar a venda selecionada.`
    : `Marcando essa opção o <span class="font-weight-medium">Systock</span> irá considerar a venda selecionada.`
});

function desconsiderarPedidosConsumos() {
  const pedidos = props.pedidos
    .filter(item => DESCONSIDERAR_PEDIDO_TRANSITO_COMPUTED.value ? !item.pedido_desconsiderado : item.pedido_desconsiderado)
    .map(item => ({
      filial: item.filial,
      idconsumo: item.idconsumo,
      emissao: item.emissao,
      idproduto: item.idproduto,
      item: item.item,
      status: item.status,
      horariomov: item.horariomov
    }));

  const params = {
    idgrupo: props.idgrupo,
    idfornecedor: props.idfornecedor,
    pedidos,
  };

  api.post('produtos/consumos/desconsideradas', params)
    .then(() => {
      dialog_ativo.value = false;
      emit('consumos-desconsiderados', {});
    })
    .catch(logout)
}
</script>
